<template>
  <div id="popup">
    <div class="top">
      <modal-actions :back-action="backAction" :close-action="closeAction" dark-text/>
      <slot name="top-content"></slot>
    </div>

    <div class="colored-separator"></div>

    <div v-if="hasBottomSlot">
      <div class="bottom">
        <slot name="bottom-content"></slot>
      </div>

      <separator/>
    </div>

    <div class="footer" v-if="hasFooterSlot">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import ModalActions from '../ModalActions.vue';
import Separator from '../Separator.vue';

export default {
  name: 'Popup',
  components: {
    ModalActions,
    Separator,
  },
  props: {
    closeAction: {
      type: Function,
      require: false,
      default: null,
    },
    backAction: {
      type: Function,
      require: false,
      default: null,
    },
  },
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
    hasBottomSlot() {
      return !!this.$slots['bottom-content'];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/border-radius';
  @import '../../scss/riseup-colors';

  #popup {
    .top {
      position: relative;
      padding: 40px 24px;
      border-radius: $popup-border-radius $popup-border-radius 0 0;
    }

    .colored-separator {
      height: 3px;
      width: 100%;
      background-color: $riseup_blue;
    }

    .bottom {
      padding: 24px;
    }
    .footer {
      padding: 24px;
    }

    &.primary .colored-separator {
      background-color: $riseup_blue;
    }

    &.success .colored-separator {
      background-color: $riseup_green;
    }

    &.warning .colored-separator {
      background-color: $riseup_yellow;
    }

    &.danger .colored-separator {
      background-color: $riseup_danger_red;
    }

    &.fixed .colored-separator {
      background-color: $riseup_red;
    }

    &.savings .colored-separator {
      background-color: $riseup_savings;
    }
  }
</style>
